<template>
    <div>
        <!-- Modal Component -->
        <b-modal v-model="openModal" title="New Metric" size="lg" ok-title="Save Metric" ok-variant="success" :ok-disabled="saving" :cancel-disabled="saving" no-fade @hide="handleHide" @hidden="handleHidden" @ok="handleOk" ref="metricModal" :no-close-on-backdrop="true" scrollable>

            <div class="form-group row">
                <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.metric_name }">Metric Name:</label>
                <div class="col-md-8">
                    <input type="text" v-model="metric.metric_name" :class="{ 'form-control': true, 'is-invalid': errors.metric_name }" placeholder="Enter a Name for this Metric" />

                    <div v-if="errors.metric_name" class="text-danger">
                        <span v-for="error in errors.metric_name">{{ error }}</span>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.num_years_average }"># of Years to Average:</label>
                <div class="col-md-8">
                    <input type="text" v-model="metric.num_years_average" :class="{ 'form-control': true, 'is-invalid': errors.num_years_average }" placeholder="Enter the Number of Years EHS should average together" />
                    <small>Enter 1 if you just want to use the most recent year.</small>

                    <div v-if="errors.num_years_average" class="text-danger">
                        <span v-for="error in errors.num_years_average">{{ error }}</span>
                    </div>
                </div>
            </div>
            <hr/>

            <h6 class="mb-0">Subcontractor Conditions (Optional) <b-button size="sm" variant="success" v-on:click="newMetricCondition()" title="New Condition"><i class="fa fa-plus-circle"></i></b-button></h6>
            <small class="text-muted">These are simply conditional operators to filter the subcontractors for this rule. NOTE: These filters do not equate to failure, but rather N/A.</small>

            <template v-for="(cond, index) in metric.conditions">
                <div class="row mb-1">
                    <div class="col-sm-5">
                        <b-form-select v-model="cond.attribute" :options="subConditions" size="sm" plain :class="{'is-invalid': errors['conditions.'+index+'.attribute'] }" />
                        <div v-if="errors['conditions.'+index+'.attribute']" class="text-danger">
                            <span v-for="error in errors['conditions.'+index+'.attribute']">{{ error }}</span>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <b-form-select v-model="cond.logic" :options="logicalOperators" size="sm" plain :class="{'is-invalid': errors['conditions.'+index+'.logic'] }" />
                        <div v-if="errors['conditions.'+index+'.logic']" class="text-danger">
                            <span v-for="error in errors['conditions.'+index+'.logic']">{{ error }}</span>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <b-form-input type="text" v-model="cond.value" size="sm" placeholder="Enter the Condition Value" :class="{'is-invalid': errors['conditions.'+index+'.value'] }" />
                        <div v-if="errors['conditions.'+index+'.value']" class="text-danger">
                            <span v-for="error in errors['conditions.'+index+'.value']">{{ error }}</span>
                        </div>
                    </div>
                    <div class="col-sm-1">
                        <b-button size="xs" variant="danger" v-on:click="deleteCondition(index)" title="Delete Condition"><i class="fa fa-trash"></i></b-button>
                    </div>
                </div>
            </template>
            <hr/>

            <h6 class="mb-0 mt-4">Subcontractor Rules  <b-button size="sm" variant="success" v-on:click="newMetricRule()" title="New Rule"><i class="fa fa-plus-circle"></i></b-button></h6>


            <div class="mb-4 form-inline">
                <label :class="{'is-invalid': errors.min_passing_rules}">Minimum Number of Rules Required to Pass:</label>&nbsp;

                <b-form-input type="text" size="sm" v-model="metric.min_passing_rules" :class="{'is-invalid': errors.min_passing_rules}" placeholder="Min # of Passing Rules"></b-form-input><br/>

                <small class="text-muted">This is the minimum number of rules that <strong>must pass</strong> for the metric to be approved. It excludes Immediate Fail rules.</small>

                <div v-if="errors.min_passing_rules" class="text-danger">
                    <span v-for="error in errors.min_passing_rules">{{ error }}</span>
                </div>
            </div>

            <div class="row mb-1">
                <div class="col-sm-1">
                    IFR <i class="fa fa-question-circle" title="Immediate Failure Rule. If this is checked, the rule in question MUST pass, regardless of the minimum passing rules value above"></i>
                </div>
                <div class="col-sm-5">
                    Data Point
                </div>
                <div class="col-sm-2">
                    Logic
                </div>
                <div class="col-sm-4">
                    Value
                </div>
                <div class="col-sm-1">

                </div>
            </div>
            <template v-for="(rule, index) in metric.rules">
                <div class="row mb-1">
                    <div class="col-sm-1">
                        <b-form-checkbox v-model="rule.immediate_fail" plain />
                    </div>
                    <div class="col-sm-4">
                        <b-form-select v-model="rule.attribute" :options="usabledFields" size="sm" plain :class="{'is-invalid': errors['rules.'+index+'.attribute'] }" />
                        <div v-if="errors['rules.'+index+'.attribute']" class="text-danger">
                            <span v-for="error in errors['rules.'+index+'.attribute']">{{ error }}</span>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <b-form-select v-model="rule.logic" :options="logicalOperators" size="sm" plain :class="{'is-invalid': errors['rules.'+index+'.logic'] }" />
                        <div v-if="errors['rules.'+index+'.logic']" class="text-danger">
                            <span v-for="error in errors['rules.'+index+'.logic']">{{ error }}</span>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <b-form-input type="text" v-model="rule.value" size="sm" placeholder="Enter the Rule Value" :class="{'is-invalid': errors['rules.'+index+'.value'] }" />
                        <div v-if="errors['rules.'+index+'.value']" class="text-danger">
                            <span v-for="error in errors['rules.'+index+'.value']">{{ error }}</span>
                        </div>
                    </div>
                    <div class="col-sm-1">
                        <b-button size="xs" variant="danger" v-on:click="deleteRule(index)" title="Delete Rule"><i class="fa fa-trash"></i></b-button>
                    </div>
                </div>
            </template>
            <div v-if="errors.rules" class="text-danger">
                <span v-for="error in errors.rules">{{ error }}</span>
            </div>

        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {

            clientId: {
                type: Number,
                required: true,
            },
        },

        data: function() {
            return {
                openModal: false,
                saving: false,
                errors: {},
                metric: {
                    conditions: [],
                    rules: [],
                },
                subConditions: [
                    {value: null, text: '-- Select a Condition --'},
                    {value: 'company_size', text: '# of Employees'},
                ],
                logicalOperators: [
                    {value: '<', text: '<'},
                    {value: '<=', text: '<='},
                    {value: '==', text: '='},
                    {value: '>', text: '>'},
                    {value: '>=', text: '>='}
                ],
                usabledFields: [
                    {value: 'emr', text: 'EMR'},
                    {value: 'fatalities', text: 'Fatalities'},
                    {value: 'cited_fatalities', text: 'Cited Fatalities'},
                    {value: 'lost_work_days', text: 'Lost Work Days'},
                    {value: 'transfer_restriction_cases', text: 'Job Transfer or Restriction Days'},
                    {value: 'other_recordable_cases', text: 'Other Recordable Cases'},
                    {value: 'hours_worked', text: 'Hours Worked'},
                    {value: 'epa_state_violations', text: 'EPA/State Violations'},
                    {value: 'total_recordable_cases', text: 'Total Recordable Cases'},
                    {value: 'incident_rate', text: 'Total Recordable Incident Rate'},
                    {value: 'first_aid_cases', text: 'First Aid Cases'},
                    {value: 'dart', text: 'DART'},
                    //{value: 'lwir', text: 'LWIR'},
                    {value: 'osha_serious_citations', text: 'OSHA Serious Violations'},
                    {value: 'osha_repeat_citations', text: 'OSHA Repeat Violations'},
                    {value: 'osha_willful_citations', text: 'OSHA Willful Violations'},
                    {value: 'osha_other_citations', text: 'OSHA Other-Than-Serious Violations'},
                ],
            }
        },

        methods: {

            handleHide(bvEvt){

            },

            handleHidden(bvEvt){
                //Reset the values
                this.metric = {};
                this.errors = {};
            },

            handleOk: function(bvEvt) {

               //Stops the modal from closing
               bvEvt.preventDefault();

               //Do it
               this.saveMetric();
            },

            setModel(metric = null){
                //Check for null
                if(metric == null)
                {
                    this.metric = {
                        conditions: [],
                        rules: [],
                    };
                }
                else
                {
                    this.metric = metric;
                }
            },

            showModal(){
                //Open the modal
                this.openModal = true;

                //Push a new condition and rule if emtpy
                if(this.metric.conditions.length == 0)
                {
                    //this.newMetricCondition();
                }

                //Push a new condition and rule if emtpy
                if(this.metric.rules.length == 0)
                {
                    this.newMetricRule();
                }
            },

            newMetricCondition(){
                this.metric.conditions.push({});
            },

            deleteCondition(index){
                //Splice and reset
                this.metric.conditions.splice(index, 1);
            },

            newMetricRule(){
                this.metric.rules.push({});
            },

            deleteRule(index){
                //Splice and reset
                this.metric.rules.splice(index, 1);
            },

            saveMetric(){
                //Saving indicator
                this.saving = true;

                //Send it
                this.$http
                .post('clients/metric/' + this.clientId, this.metric)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Metric Saved');

                    //Emit
                    this.$emit('metricSaved', response.data);
                    //this.$store.commit('updateMetrics', response.data);

                    //Close the modal
                    this.$refs.metricModal.hide();

                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //SEt the height
            //this.$refs.metricModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';
        }
    }
</script>